module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/76bd82066d561af4a3e8ff1c32f093fb.svg";